// JS for block-specific behavior only
console.log('res split paragraph block loaded');